import { Brick, registerBrick } from 'olympe';
import { getLogger } from '@olympeio/core';
import { string } from 'prop-types';

export default class ExtractUserDisplayNameAndEmail extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {*} inputObj
     * @param {function(string)} setConcatenatedResult
     */
    update($, [inputObj], [setConcatenatedResult]) {
        // Write your code here.
        // Check https://olympe.support for documentation.
        // Check https://github.com/olympeio/CORE for examples.
        //
        // This method is executed the first time when all inputs have a value
        // and then anytime an input receives a new value.
        // Override `setupExecution()` to change this behavior.
        var logger = getLogger("ExtractUserDisplayNameAndEmail");
        
        logger.info("InputObj: ", inputObj);
        
        const displayName = inputObj.displayName ?? "";
        const email = (inputObj.mail ?? "").toLowerCase();

        logger.info("displayName: ", displayName);
        logger.info("email: ", email);
        logger.info("Concatenated Value: ", `${displayName};${email}`);

        setConcatenatedResult(`${displayName};${email}`);
    }
}

registerBrick('019ffaf6a606bc31477d', ExtractUserDisplayNameAndEmail);
